module.exports = __webpack_public_path__ + "static/media/indianRoulette.67addc3d.png";